module.exports = __webpack_public_path__ + "media/images/site-section/header-background-palm-66221f8350fd8843224734f4f3c68639.jpg";